(function() {
  const carousel = document.querySelector('[data-carousel]');
  if (!carousel) return;

  const items = Array.from(carousel.querySelectorAll('.landing-carousel__item'));
  const total = items.length;
  let active = Math.floor(total / 2);

  function getPos(itemIndex) {
    const diff = ((itemIndex - active) % total + total) % total;
    if (diff === 0) return 'center';
    if (diff === total - 1) return 'left';
    if (diff === 1) return 'right';
    return 'hidden';
  }

  function applyPositions(animated) {
    items.forEach((item, i) => {
      const pos = getPos(i);
      if (!animated) item.style.transition = 'none';
      item.setAttribute('data-pos', pos);
      item.classList.toggle('is-active', pos === 'center');
      item.querySelector('button').setAttribute('aria-pressed', pos === 'center');
      if (!animated) {
        void item.offsetWidth;
        item.style.transition = '';
      }
    });
  }

  function rotateTo(index) {
    const prev = active;
    const diff = ((index - prev) % total + total) % total;
    const goingRight = diff === 1; // clicking right item → left item should be back

    // Find the far item BEFORE updating active
    const farItem = items.find((_, i) => {
      const oldDiff = ((i - prev) % total + total) % total;
      return goingRight ? oldDiff === total - 1 : oldDiff === 1;
    });

    items.forEach(item => {
      item.classList.remove('is-back');
      item.querySelector('.landing-carousel__product-img').classList.remove('is-levitating');
    });
    if (farItem) farItem.classList.add('is-back');

    active = index;
    carousel.classList.add('is-rotating');
    applyPositions(true);

    setTimeout(() => {
      if (farItem) farItem.classList.remove('is-back');
      carousel.classList.remove('is-rotating');
    }, 650);
  }

  // Intro: center fades in first, then side items snap out
  items.forEach((item, i) => {
    item.style.transition = 'none';
    item.setAttribute('data-pos', 'center');
    item.classList.toggle('is-active', i === active);
    item.querySelector('button').setAttribute('aria-pressed', String(i === active));
    item.style.opacity = '0';
    item.style.zIndex = i === active ? '10' : '1';
  });

  void carousel.offsetWidth;

  // Reveal carousel, then fade in center item
  carousel.style.transition = 'opacity 0.3s ease';
  carousel.classList.add('is-ready');

  const centerItem = items[active];
  centerItem.style.transition = 'opacity 0.45s ease';
  centerItem.style.opacity = '1';

  setTimeout(() => {
    // Snap side items out from center
    items.forEach((item, i) => {
      const pos = getPos(i);
      item.style.transition = 'transform 0.55s cubic-bezier(0.68, -0.4, 0.265, 1.4), opacity 0.3s ease, z-index 0s';
      item.style.opacity = '1';
      item.setAttribute('data-pos', pos);
      item.classList.toggle('is-active', pos === 'center');
    });
    setTimeout(() => {
      items.forEach(item => {
        item.style.transition = '';
        item.style.opacity = '';
        item.style.zIndex = '';
      });
      carousel.style.transition = '';
    }, 600);
  }, 500);

  items.forEach((item, i) => {
    item.querySelector('button').addEventListener('click', () => {
      if (i === active) {
        const cta = item.querySelector('.landing-carousel__cta');
        if (cta) window.location.href = cta.href;
        return;
      }
      rotateTo(i);
    });

    const img = item.querySelector('.landing-carousel__product-img');
    item.addEventListener('mouseenter', () => {
      if (carousel.classList.contains('is-rotating')) return;
      const pos = item.getAttribute('data-pos');
      if (pos !== 'left' && pos !== 'right') return;
      img.classList.add('is-levitating');
    });
    item.addEventListener('mouseleave', () => {
      if (!img.classList.contains('is-levitating')) return;
      const currentY = new DOMMatrix(getComputedStyle(img).transform).m42;
      img.classList.remove('is-levitating');
      img.style.transform = `translateY(${currentY}px)`;
      img.style.transition = 'transform 0.5s ease';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        img.style.transform = 'translateY(0)';
        setTimeout(() => { img.style.transform = ''; img.style.transition = ''; }, 500);
      }));
    });
  });

  // Swipe (touch + mouse)
  const track = carousel.querySelector('[data-track]');
  let dragStartX = null;
  let isDragging = false;
  const SWIPE_THRESHOLD = 40;

  function onDragStart(x) { dragStartX = x; isDragging = false; }
  function onDragMove(x) {
    if (dragStartX === null) return;
    if (Math.abs(x - dragStartX) > 10) isDragging = true;
  }
  function onDragEnd(x) {
    if (dragStartX === null) return;
    const delta = x - dragStartX;
    dragStartX = null;
    if (!isDragging || Math.abs(delta) < SWIPE_THRESHOLD) return;
    rotateTo(delta < 0 ? (active + 1) % total : (active - 1 + total) % total);
  }

  track.addEventListener('touchstart', (e) => onDragStart(e.touches[0].clientX), { passive: true });
  track.addEventListener('touchmove', (e) => {
    onDragMove(e.touches[0].clientX);
    if (isDragging) e.preventDefault();
  }, { passive: false });
  track.addEventListener('touchend', (e) => onDragEnd(e.changedTouches[0].clientX), { passive: true });

  track.addEventListener('mousedown', (e) => { e.preventDefault(); onDragStart(e.clientX); });
  window.addEventListener('mousemove', (e) => { if (dragStartX !== null) onDragMove(e.clientX); });
  window.addEventListener('mouseup', (e) => onDragEnd(e.clientX));
})();
